import api from '../../auth/apiClient';
import { SAKTI_API_CONFIG } from '../apiConfig';
import {
  SaktiRkhDetailResponse,
  SaktiRkhDetailUpdatePayload,
  SaktiRkhFilters,
  SaktiRkhHarvesterListResponse,
  SaktiRkhKpiResponse,
  SaktiRkhListResponse,
} from '../types';

const buildRkhParams = (filters: SaktiRkhFilters) => {
  const params: Record<string, string | number> = {
    date: filters.date,
    company_id: filters.company_id ?? 1,
    page: filters.page,
    limit: filters.limit,
  };

  if (filters.estate_id) {
    params.estate_id = filters.estate_id;
  }

  if (filters.division_id) {
    params.division_id = filters.division_id;
  }

  return params;
};

export class SaktiRkhApiService {
  static async getKpi(filters: SaktiRkhFilters): Promise<SaktiRkhKpiResponse> {
    const response = await api.get<SaktiRkhKpiResponse>(SAKTI_API_CONFIG.RKH_KPI_PATH, {
      params: buildRkhParams(filters),
    });

    return response.data;
  }

  static async getRkhList(filters: SaktiRkhFilters): Promise<SaktiRkhListResponse> {
    const response = await api.get<SaktiRkhListResponse>(SAKTI_API_CONFIG.RKH_LIST_PATH, {
      params: buildRkhParams(filters),
    });

    return response.data;
  }

  static async getHarvestersList(
    filters: SaktiRkhFilters
  ): Promise<SaktiRkhHarvesterListResponse> {
    const response = await api.get<SaktiRkhHarvesterListResponse>(
      SAKTI_API_CONFIG.RKH_HARVESTERS_PATH,
      {
        params: buildRkhParams(filters),
      }
    );

    return response.data;
  }

  static async getRkhDetail(rkhId: string): Promise<SaktiRkhDetailResponse> {
    const response = await api.get<SaktiRkhDetailResponse>(
      SAKTI_API_CONFIG.RKH_DETAIL_PATH(rkhId)
    );

    return response.data;
  }

  static async updateRkhDetail(
    rkhId: string,
    payload: SaktiRkhDetailUpdatePayload
  ): Promise<SaktiRkhDetailResponse> {
    const response = await api.put<SaktiRkhDetailResponse>(
      SAKTI_API_CONFIG.RKH_DETAIL_PATH(rkhId),
      payload
    );

    return response.data;
  }
}

export default SaktiRkhApiService;
